module.exports = __webpack_public_path__ + "img/innerbanner.d148f0d1.webp";